// extracted by mini-css-extract-plugin
module.exports = {"activity_page":"cartoonGuide_activity_page__2t3wP","imageContent":"cartoonGuide_imageContent__2CjhB","btn_box":"cartoonGuide_btn_box__1fg98","mask":"cartoonGuide_mask__20Zrr"};